import { Component, OnInit, inject } from '@angular/core';
import { ImpersonateService } from '../../../../services/impersonate.service';
import { LoadingStore } from '../../../../stores/loading.store';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getStorageObject } from '../../../../utils/storage-manager';

@Component({
  selector: 'app-user-to-impersonate-data-modal',
  templateUrl: './user-to-impersonate-data-modal.component.html',
  styleUrls: ['./user-to-impersonate-data-modal.component.scss']
})
export class UserToImpersonateDataModalComponent implements OnInit {
  protected data = inject(MAT_DIALOG_DATA);
  private impersonateService = inject(ImpersonateService);
  private loading = inject(LoadingStore);

  /**
   * Whether checkbox is checked
   */
  activateLogs = false;

  /**
   * Whether to activate logs for the impersonated user
   */
  canViewLogs = false;

  ngOnInit(): void {
    this.canViewLogs = getStorageObject('userData')?.roles.includes('admin');
  }

  async getToken(): Promise<void> {
    try {
      this.loading.start();
      await this.impersonateService.getToken(this.data.email, this.activateLogs);
    } finally {
      this.loading.stop();
    }
  }
}
